import './FieldSelect.less'

import { Icon } from 'antd'
import Search from 'antd/lib/input/Search'
import React, { useState } from 'react'
import { MetadataAttribute } from 'api'

interface FieldSelectProps {
	fieldList: MetadataAttribute[]
	selectedFieldList: MetadataAttribute[]
	onChange?: (selectedField: MetadataAttribute, selectedFieldList?: MetadataAttribute[]) => void
}
export const FieldSelect = (props: FieldSelectProps) => {
	const [show, setShow] = useState(false)
	const [search, setSearch] = useState('')
	const checkedItem = (e: any, field: MetadataAttribute) => {
		e.nativeEvent.stopImmediatePropagation()
		e.stopPropagation()
		let selectedFieldList = (props.selectedFieldList && [...props.selectedFieldList]) || ([] as any[])
		if (selectedFieldList && selectedFieldList.find(s => s.field === field.name)) {
			selectedFieldList = selectedFieldList.filter(s => s.field !== field.name)
		} else {
			selectedFieldList.push(field)
		}
		props.onChange && props.onChange(field, selectedFieldList)
	}
	const chgShow = (e: any) => {
		if (!show) {
			e.nativeEvent.stopImmediatePropagation()
			e.stopPropagation()
			document.onclick = () => {
				setShow(false)
				document.onclick = null
			}
		} else {
			document.onclick = null
		}
		setShow(!show)
	}
	const chgSearch = (e: any) => {
		e.nativeEvent.stopImmediatePropagation()
		e.stopPropagation()
		setSearch(e.target.value)
	}
	return (
		<div className="field-select" tabIndex={-1} onClick={e => chgShow(e)}>
			<div className="text">新增字段</div>
			<span className="dropdown icon">
				<Icon type="down" className="down" />
			</span>
			<div
				className={`menu transition ${show ? '' : 'hidden'}`}
				onClick={e => {
					e.nativeEvent.stopImmediatePropagation()
					e.stopPropagation()
				}}
			>
				<div className="ui icon search input">
					<Search placeholder="搜索字段..." onChange={e => chgSearch} style={{ width: 200 }} />
				</div>
				<div className="menu-list">
					{props.fieldList &&
						props.fieldList
							.filter(
								f => search === '' || f.name.indexOf(search) >= 0 || f.displayName.indexOf(search) >= 0
							)
							.map((field: any) => {
								let check = props.selectedFieldList.find(f => f.name === field.name)
								return (
									<div
										key={field.id}
										className={`field-select-dropdown-item item ${check ? 'item-checked' : ''}`}
										onClick={e => checkedItem(e, field)}
									>
										<div className="ui checkbox checked" style={{ marginRight: '10px' }}>
											<label>
												<i
													className={
														check
															? 'qcciconfont-checkbox-line checkbox-icon'
															: 'qcciconfont-checkbox-blank-line checkbox-icon'
													}
												/>
												<div className="checkbox__label">
													<span className="checkbox__label__text">{field.displayName}</span>
													<br />
													<span className="checkbox__label__value">{field.name}</span>
												</div>
											</label>
										</div>
									</div>
								)
							})}
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/FieldSelect.tsx